/* ==========================================================================
   ÄNDERN MOTORSPORT — Global Core Script
   Purpose: Initializes namespace and shared behaviors
   ========================================================================= */

window.Andern = window.Andern || {};

(function () {
  "use strict";

  Andern.init = function () {
    console.log("✅ Ändern Core Initialized");

    // Example shared site interactions:
    Andern.lazyImages();
  };

  Andern.lazyImages = function () {
    const lazyImgs = document.querySelectorAll("img[data-src]");
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          obs.unobserve(img);
        }
      });
    });
    lazyImgs.forEach(img => observer.observe(img));
  };

  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", Andern.init);
})();

/* ==========================================================================
   ÄNDERN MOTORSPORT — SMOOTH ACCORDION ANIMATION
   Lightweight + native CSS transitions for premium feel
   ========================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".andern-accordion details");

  accordions.forEach((detail) => {
    detail.addEventListener("toggle", (e) => {
      const content = e.target.querySelector("p, ul, div");
      if (!content) return;

      if (detail.open) {
        content.style.height = "auto";
        const height = content.clientHeight + "px";
        content.style.height = "0px";
        setTimeout(() => (content.style.height = height), 10);
        setTimeout(() => (content.style.height = "auto"), 350);
      } else {
        const height = content.clientHeight + "px";
        content.style.height = height;
        setTimeout(() => (content.style.height = "0px"), 10);
      }
    });
  });
});
